import { api } from "./api";

export const ALLOWED_EXT = ["pdf", "jpg", "jpeg", "png", "doc", "docx", "xls", "xlsx", "zip", "rar", "7z", "rtf", "txt"];
export const ARCHIVE_EXT = ["zip", "rar", "7z"];
export const isArchive = (name) => ARCHIVE_EXT.includes(fileExt(name || ""));
// file inputs have no picker filter: files without extension load when the server recognises their content
// mirrors backend filestore.sniff_candidate
export const sniffCandidate = (name) => {
  const ext = fileExt(name);
  return !ALLOWED_EXT.includes(ext) && (ext === "" || !/^[a-z]{1,5}$/.test(ext));
};
export const MAX_BYTES = 200 * 1024 * 1024;
export const MSG = {
  format: "Formato no permitido",
  size: "El archivo supera 200 MB",
  upload: "No se pudo subir el archivo, intenta de nuevo",
};

export const fileExt = (name) => (name.includes(".") ? name.split(".").pop().toLowerCase() : "");

export function validateFile(file) {
  if (!ALLOWED_EXT.includes(fileExt(file.name)) && !sniffCandidate(file.name)) return MSG.format;
  if (file.size > MAX_BYTES) return MSG.size;
  return null;
}

export async function fetchBlob(id, mode, basePath = "/documents") {
  const r = await api.get(`${basePath}/${id}/${mode}`, { responseType: "blob" });
  return r.data;
}

export function saveBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export async function downloadFile(file, basePath = "/documents") {
  saveBlob(await fetchBlob(file.id, "download", basePath), file.original_filename);
}
